// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { parseColor } from './utils/color-parser';
import { isPresent } from './utils/misc';
import { Input as KInput } from '../input/Input';
/**
 * @hidden
 */

var HexInputVue2 = {
  name: 'KendoHexInput',
  // @ts-ignore
  emits: {
    'hexchange': null,
    'blur': null,
    'focus': null
  },
  props: {
    tabIndex: Number,
    hex: String,
    disabled: Boolean
  },
  computed: {
    isHexValid: function isHexValid() {
      return !!parseColor(this.currentHex, 'rgba');
    }
  },
  data: function data() {
    return {
      currentHex: this.$props.hex,
      originalHex: this.$props.hex
    };
  },
  mounted: function mounted() {
    this._input = this.$refs.input._input;
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  watch: {
    hex: function hex(newValue) {
      this.currentHex = newValue;
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h(KInput, {
      value: this.currentHex,
      attrs: this.v3 ? undefined : {
        value: this.currentHex,
        valid: this.isHexValid,
        disabled: this.$props.disabled,
        tabIndex: this.tabIndex
      },
      onInput: this.onChange,
      on: this.v3 ? undefined : {
        "input": this.onChange,
        "change": this.onChange,
        "focus": this.onFocus,
        "blur": this.onBlur
      },
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      valid: this.isHexValid,
      disabled: this.$props.disabled,
      tabIndex: this.tabIndex,
      ref: 'input'
    });
  },
  methods: {
    onChange: function onChange(event) {
      var hex = event.target.value;
      var value = parseColor(hex, 'rgba');
      this.currentHex = hex;

      if (isPresent(value)) {
        this.$emit('hexchange', {
          hex: hex,
          value: value,
          event: event
        });
      }
    },
    onBlur: function onBlur(event) {
      if (!isPresent(parseColor(this.hex, 'rgba'))) {
        this.currentHex = this.originalHex;
      }

      this.$emit('blur', event);
    },
    onFocus: function onFocus(event) {
      this.$emit('focus', event);
    }
  }
};
/**
 * @hidden
 */

var HexInput = HexInputVue2;
export { HexInput, HexInputVue2 };